module.exports = __webpack_public_path__ + "static/media/ads (2).d3cc2ef2.png";